import {AccountService} from "../../core/services/AccountService"
export class LoginPageComponent implements ng.IComponentOptions {
    public controller: any = LoginController;
    public template: string =
    `<div class="container container-fluid">
      <div class="row">
      <div class="col-xs-12 main-content">
      <div class="logincontainer">
        <div class="header-lined"><h1>Login</h1></div>
        <span class="text-danger" ng-show="$ctrl.loginForm.$invalid">Please fill in all fields</span>
        <span class="text-danger" ng-show="$ctrl.error.login">{{$ctrl.errorMsg}}</span>
        <form role="form" name="loginForm">
          <div class="input-group margin-top">
            <span class="input-group-addon">
            <i class="fa fa-user"></i>
            </span>
            <input type="text" name="email" class="form-control" id="inputEmail" placeholder="Enter Email" autofocus="" ng-model="$ctrl.form.email" required>
          </div>
          <div class="input-group margin-top">
            <span class="input-group-addon">
            <i class="fa fa-lock"></i>
            </span>
            <input type="password" class="form-control" placeholder="Enter Password" ng-model="$ctrl.form.password" required>
          </div>
          <div class="checkbox checkbox-primary margin-top-2">
            <input id="checkbox2" class="styled" type="checkbox" ng-model="$ctrl.form.rememberMe">
            <label for="checkbox2">
              Remember Me
            </label>
          </div>
          <div vc-recaptcha key="'6LcKTiEUAAAAAKpzpt0NRtR2I9EGTrPn1_Oz3cp5'" ng-model="$ctrl.form.recaptcha"></div>
          <div class="clearfix margin-top-2">
            <button type="submit" class="btn btn-primary" ng-click="loginForm.$valid && $ctrl.login()">Login</button>
            <button type="submit" class="btn btn-default" ng-click="$ctrl.register()">Register</button>
          </div>
        </form>
      </div>
      <div class="logincontainerfooter">
        <a href="#/forget-password" class="">Forgot Password?</a>
      </div>
      </div>
        </div>
    </div>`;
}
export class LoginController {
    public static $inject: Array<string> = ["AccountService", "$location"];
    public tree: Array<Object>;
    public form: any;
    public error: any;
    public errorMsg: string;

    constructor(public account: AccountService, private $location: ng.ILocationService) {
      this.tree = [
        {name: "Login", path: "#/login", active: true}
      ];
      this.error = {};
      this.form = {rememberMe: true};
    }

    public login(): void {
      this.account.login(this.form.email, this.form.password, this.form.rememberMe, this.$location.search().redirect)
      .then(d => {
        this.error.login = false;
        this.account.me();
      })
      .catch(err => {
        this.error.login = true;
        if (err && err.code === 101) {
          this.errorMsg = "Account Pending for Approval";
        }
        else if (err && err.code === 102) {
          this.errorMsg = "Account Inactive (please contact system administrator)";
        }
        else {
          this.errorMsg = "Invalid Email or Password";
        }
      });
    }

    public register():void {
      this.$location.path("/register");
    }
}
